import Vue from 'vue'
import { mergeProps } from 'util/ts-utils'

import './grid-layout.scss'

const VERTICAL_SPACING_CLASS = ''

export interface ILayoutColumn {
  width: number,
  rightMargin?: number
  items: Array<String>
}
export interface ILayout {
  headerItems: Array<string>,
  columns: Array<ILayoutColumn>,
  footerItems: Array<string>
}
export interface ILayoutConfig {
  breakpoint: number,
  layout: ILayout
}

export default Vue.extend({
  props: {
    layout: { type: Object },
    classPrefix: { type: String }
  },
  methods: {
    createSection(h, slotNames, classes, width, rightMargin = 0) {
      const childNodes = []
      slotNames.forEach((name) => {
        if (this.$slots[name]) {
          childNodes.push(this.$slots[name])
        }
      })
      let sectionStyle = width ? `flex: 0 0 auto;width: ${width}%;` : ''
      sectionStyle += rightMargin ? `margin-right: ${rightMargin}%` : ''
      return this.createElement(h, childNodes, classes, sectionStyle)
    },
    createElement(createElement, childNodes, elementClass, elementStyle = '') {
      const attrs = { class: elementClass } as any
      if (elementStyle) {
        attrs.style = elementStyle
      }
      return createElement('div', attrs, childNodes)
    },
    classesForSuffix(classSuffix) {
      const sectionClasses = {}
      sectionClasses[`tt-l-grid__${classSuffix}`] = true
      sectionClasses[`${this.classPrefix}__grid-${classSuffix}`] = this.classPrefix
      return sectionClasses
    }
  },
  render(h) {
    const headerNodes = []
    if (this.layout.headerItems.length) {
      const classes = this.classesForSuffix('header')
      classes[VERTICAL_SPACING_CLASS] = true
      const header = this.createSection(h, this.layout.headerItems, classes)
      headerNodes.push(header)
    }

    const middleRowNodes = []
    this.layout.columns.forEach((column, i) => {
      if (column.items.length) {
        const classes =
          mergeProps(this.classesForSuffix('col'), this.classesForSuffix(`col--${i + 1}`))
        classes[VERTICAL_SPACING_CLASS] = true
        const columnSection =
          this.createSection(h, column.items, classes, column.width, column.rightMargin)
        middleRowNodes.push(columnSection)
      }
    })

    const footerNodes = []
    if (this.layout.footerItems.length) {
      const classes = this.classesForSuffix('footer')
      classes[VERTICAL_SPACING_CLASS] = true
      const footer = this.createSection(h, this.layout.footerItems, classes)
      footerNodes.push(footer)
    }

    const rowClasses = this.classesForSuffix('row')

    const rows = []
    if (headerNodes) {
      rows.push(this.createElement(h, headerNodes, rowClasses))
    }
    if (middleRowNodes) {
      rows.push(this.createElement(h, middleRowNodes, rowClasses))
    }
    if (footerNodes) {
      rows.push(this.createElement(h, footerNodes, rowClasses))
    }
    return this.createElement(h, rows, `tt-l-grid ${VERTICAL_SPACING_CLASS}`)
  }
})



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/layouts/grid/grid-layout.ts